import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ErrorReportHost } from '@dlap-ui/shared-forms/tickets/report-issue/error-report-host';

@Component({
  imports: [RouterModule, ErrorReportHost],
  selector: 'app-root',
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App {
  protected title = 'law-firm';
}
